let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("38Txo")).then(() => parcelRequire('afSyV'));